import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import apiPath from "../../../utils/pathObj";
import { apiGet, apiPut } from "../../../utils/apiFetch";
import GridLayout from "react-grid-layout";
import useToastContext from 'hooks/useToastContext'
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const OnboardingView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const { id } = location?.state || {};
  const [formData, setFormData] = useState(null);
  const [fieldValues, setFieldValues] = useState({});
  const [layouts, setLayouts] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Load saved layouts from localStorage
  useEffect(() => {
    if (id) {
      const savedLayouts = localStorage.getItem(`layouts-${id}`);
      if (savedLayouts) {
        setLayouts(JSON.parse(savedLayouts));
      }
      fetchFormData();
    } else {
      navigate("/forms-manager");
    }
  }, [id]);

    const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  console.log(containerWidth, "container width");

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
        console.log(entry.contentRect.width, "new container width");
      setContainerWidth(entry.contentRect.width);
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  console.log(layouts, "layouts");

  const handleLayoutChange = (newLayout, groupIndex) => {
    setLayouts((prevLayouts) => {
      const updatedLayouts = { ...prevLayouts, [groupIndex]: newLayout };

      // Add layout data into formData.customFields
      if (formData?.customFields?.[groupIndex]) {
        const updatedFields = formData.customFields[groupIndex].map(
          (field, fieldIndex) => ({
            ...field,
            layout: {
              x: newLayout[fieldIndex]?.x ?? 0,
              y: newLayout[fieldIndex]?.y ?? 0,
              w: newLayout[fieldIndex]?.w ?? 4,
              h: newLayout[fieldIndex]?.h ?? 1,
            },
          })
        );

        const updatedFormData = { ...formData };
        updatedFormData.customFields[groupIndex] = updatedFields;
        setFormData(updatedFormData);

      }

      // localStorage.setItem(`layouts-${id}`, JSON.stringify(updatedLayouts));
      return updatedLayouts;
    });
  };

  const fetchFormData = async () => {
    try {
      setIsLoading(true); // Start loading
      const res = await apiGet(`${apiPath.getFormsById}/${id}`);
      const form = res?.data?.results;

      const values = {};
      const layoutByGroup = {};

      form?.customFields?.forEach((group, groupIndex) => {
        layoutByGroup[groupIndex] = group.map((field, fieldIndex) => {
          // If field has existing layout, use that
          if (field.layout) {
            return {
              i: `${groupIndex}-${fieldIndex}`,
              x: field.layout.x,
              y: field.layout.y,
              w: field.layout.w,
              h: field.layout.h,
            };
          }

          // Default layout based on field type
          let defaultWidth = 4;
          let defaultHeight = 1;

          if (field.type === "heading") {
            defaultWidth = 12;
            defaultHeight = 2;
          } else if (field.type === "textarea") {
            defaultWidth = 12;
            defaultHeight = 4;
          } else if (field.type === "checkbox" || field.type === "radio") {
            defaultWidth = 6;
          }

          return {
            i: `${groupIndex}-${fieldIndex}`,
            x: (fieldIndex % 2) * 4, // Two columns by default
            y: Infinity, // Let it auto-position vertically
            w: defaultWidth,
            h: defaultHeight,
            static: field.type === "heading",
          };
        });

        group.forEach((field, fieldIndex) => {
          const fieldId = field?.id ?? `${groupIndex}-${fieldIndex}`;
          values[fieldId] =
            field?.value || (field?.type === "checkbox" ? [] : "");
        });
      });

      // Check if we have saved layouts in localStorage
      const savedLayouts = localStorage.getItem(`layouts-${id}`);

      // Update the formData with layouts
      const updatedFormData = { ...form };
      updatedFormData.customFields = form.customFields.map(
        (group, groupIndex) =>
          group.map((field, fieldIndex) => ({
            ...field,
            layout: savedLayouts
              ? JSON.parse(savedLayouts)[groupIndex]?.[fieldIndex] || {
                x: layoutByGroup[groupIndex][fieldIndex].x,
                y: layoutByGroup[groupIndex][fieldIndex].y,
                w: layoutByGroup[groupIndex][fieldIndex].w,
                h: layoutByGroup[groupIndex][fieldIndex].h,
              }
              : {
                x: layoutByGroup[groupIndex][fieldIndex].x,
                y: layoutByGroup[groupIndex][fieldIndex].y,
                w: layoutByGroup[groupIndex][fieldIndex].w,
                h: layoutByGroup[groupIndex][fieldIndex].h,
              },
          }))
      );

      // Set all states together to prevent inconsistent renders
      setFormData(updatedFormData);
      setFieldValues(values);
      setLayouts(savedLayouts ? JSON.parse(savedLayouts) : layoutByGroup);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false); // End loading
    }
  };

  console.log(formData, "formData");

  const handleChange = (e, fieldId, type) => {
    const { value, checked, files } = e.target;

    setFieldValues((prev) => {
      if (type === "checkbox") {
        const current = prev[fieldId] || [];
        return {
          ...prev,
          [fieldId]: checked
            ? [...current, value]
            : current.filter((v) => v !== value),
        };
      }

      if (type === "file") {
        return { ...prev, [fieldId]: files[0] };
      }

      return { ...prev, [fieldId]: value };
    });
  };

  const handleUpdateForm = async () => {
    if (!formData || !formData._id) return;

    const updatedFormData = { ...formData };
    updatedFormData.customFields = formData.customFields.map(
      (group, groupIndex) =>
        group.map((field, fieldIndex) => {
          const fieldId = field?.id ?? `${groupIndex}-${fieldIndex}`;
          const layoutKey = `${groupIndex}-${fieldIndex}`;
          const layoutItem = layouts[groupIndex]?.find(
            (item) => item.i === layoutKey
          );

          return {
            ...field,
            value: "",
            // value: fieldValues[fieldId] || "",
            layout: layoutItem ||
              field.layout || {
              x: 0,
              y: 0,
              w: 4,
              h: 1,
            },
          };
        })
    );
    const payload = {
      formId: updatedFormData._id,
      formName: updatedFormData.formName,
      formType: updatedFormData.formType,
      customFields: updatedFormData.customFields,
    };

    try {
      const res = await apiPut(apiPath.updateForm, payload);
      localStorage.removeItem(`layouts-${formData._id}`);
      setLayouts({});
      notification.success(res?.data?.message || "Form updated successfully!");
      navigate("/forms-manager/view");
    } catch (error) {
      console.error("Error updating form:", error);
      notification.error(error?.res?.data?.message || 'Update failed');
    }
  };

  const renderField = (field, groupIndex, fieldIndex) => {
    const fieldId = field?.id ?? `${groupIndex}-${fieldIndex}`;
    const value = fieldValues[fieldId] ?? "";
    const { type, label, options, placeholder, mandatory, boldText, styles } = field;
    const labelStyle = "min-w-max text-xs whitespace-nowrap mr-[5px]";
    const inputStyle = "flex-1 border px-3 py-2 bg-gray-200 text-xs";

    const baseLabelStyle = "text-sm mr-2";
    const boldStyle = boldText ? "font-bold" : "font-normal";
    const requiredIndicator = mandatory ? <span className="text-red-500 ml-1">*</span> : null;

    switch (type) {
      case "text":
        return (
          <div className={`flex items-center ${styles?.container || ""}`} key={fieldId}>
            <label className={`${baseLabelStyle} ${boldStyle}`}>
              {label}
              {requiredIndicator}
            </label>
          
          </div>
        );

      case "textarea":
        return (
          <div className={`flex flex-col ${styles?.container || ""}`} key={fieldId}>
            <label className={`${baseLabelStyle} ${boldStyle}`}>
              {label}
              {requiredIndicator}
            </label>
            <textarea
              className="border border-gray-300 rounded-md shadow-sm p-2"
              placeholder={placeholder || ""}
              value={value}
              onChange={(e) => handleChange(e, fieldId, type)}
              rows={4}
            />
          </div>
        );

      case "heading":
        return (
          <div className={`w-full ${styles?.container || ""}`} key={fieldId}>
            <h2 className={`text-xl ${boldStyle}`}>
              {label}
              {requiredIndicator}
            </h2>
          </div>
        );


      case "input":
      case "select":
      case "date":
        return (
          <div className="mb-4 flex items-center gap-1" key={fieldId}>
            <label className={`text-xs ${labelStyle}`}>
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            {type === "input" && (
              <input
                type="text"
                className={inputStyle}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
                placeholder={placeholder}
              />
            )}
            {type === "date" && (
              <input
                type="date"
                className={`${inputStyle || ''} non-draggable`}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
              />
            )}
            {type === "select" && (
              <select
                className={inputStyle}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
              >
                <option value="">Select</option>
                {options?.map((opt, idx) => (
                  <option key={idx} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            )}
          </div>
        );
      case "textarea":
        return (
          <div className="mb-4" key={fieldId} style={{ clear: "both" }}>
            <div
              className="whitespace-pre-wrap  px-3 py-2 mb-10 rounded "
              style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
            >
              {value || "No content"}
            </div>
          </div>
        );
case "textEditor":
        return (
          <div className="mb-4" key={fieldId} style={{ clear: "both" }}>
            <label className={`text-sm ${labelStyle}`}>
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div
              className="px-3 py-2 mb-10 rounded border bg-white inner-html"
              // ✅ TinyMCE content can be directly rendered
              dangerouslySetInnerHTML={{ __html: value }}
            />
          </div>
        );
        case "radio":
        return (
          <div className={styles.optionsContainer} key={fieldId}>
            <label className="block mb-1 font-bold">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className=" non-draggable flex gap-4 flex-wrap">
              {options?.map((opt, idx) => (
                <label key={idx} className="non-draggable flex items-center gap-2 ">
                  <input
                    type="radio"
                    name={fieldId}
                    className="non-draggable"
                    value={opt}
                    checked={value === opt}
                    onChange={(e) => handleChange(e, fieldId, type)}
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>
        );
      case "checkbox":
        return (
          <div className={styles.optionsContainer} key={fieldId}>
            <label className="block mb-1 font-bold">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="flex gap-4 flex-wrap">
              {options?.map((opt, idx) => (
                <label key={idx} className="non-draggable flex items-center gap-2">
                  <input
                    type="checkbox"
                    name={`${fieldId}-${opt}`}
                    value={opt}
                    checked={(value || []).includes(opt)}
                    onChange={(e) => handleChange(e, fieldId, type)}
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>
        );
      case "file":
        return (
          <div className="mb-4" key={fieldId}>
            <label className="block mb-1">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            {value ? (
              <img
                src={value}
                alt="Uploaded image"
                className="max-w-xs h-auto rounded border"
              />
            ) : (
              <p className="text-gray-500 text-sm">No file uploaded</p>
            )}
          </div>
        );
      case "html":
        return (
          <div
            key={fieldId}
            className="mb-4 inner-html"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div ref={containerRef} className="bg-[#F9F9F9]">
      <div className="py-4 px-3">
        <div className="bg-white border border-[#E9EDF9] rounded-lg">
          <div className="p-6">
            {/* <h2 className="text-lg font-semibold mb-4 bg-[#E1E1E1] py-4 px-3 text-center">
              {formData?.formName} <br /> {formData?.formType}
            </h2> */}

            {formData?.customFields?.map((group, groupIndex) => (
              <GridLayout
                key={groupIndex}
                className="layout mb-3"
                cols={12}
                // rowHeight={30}
                rowHeight={20} // Optionally reduce height too
                margin={[4, 4]}
                style={{ fontSize: "12px" }}
                width={containerWidth}
                layout={layouts[groupIndex]}
                draggableCancel=".non-draggable, .ql-toolbar, .ql-container"
                isDraggable
                isResizable
                onLayoutChange={(newLayout) =>
                  handleLayoutChange(newLayout, groupIndex)
                }
              >
                {group.map((field, fieldIndex) => (
                  <div
                    key={`${groupIndex}-${fieldIndex}`}
                    data-grid={
                      layouts[groupIndex]?.[fieldIndex] ?? {
                        i: `${groupIndex}-${fieldIndex}`,
                        x: 0,
                        y: 0,
                        w: 4,
                        h: 1,
                      }
                    }
                  >
                    {renderField(field, groupIndex, fieldIndex)}
                  </div>
                ))}
              </GridLayout>
            ))}

            <div className="border-t pt-4 flex justify-center">
              <button
                onClick={() => navigate("/forms-manager")}
                className="bg-[#E1E1E1] px-12 py-2.5 rounded text-sm text-black"
              >
                {t("O_BACK")}
              </button>
              <button
                onClick={handleUpdateForm}
                className="ml-4 bg-[#007BFF] text-white px-8 py-2.5 rounded text-sm flex justify-center"
              >
                {t("SAVE")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingView;
